import {LoginResponseTwoFactor} from "../api/types/LoginResponse";
import {ApiFailure} from "../api/types/ApiResponse";

export function CheckNeedAdditionalAuth(response: ApiFailure<LoginResponseTwoFactor | null>) {
    if (!response) return null;
    if (response.errors.includes("AUTHENTICATOR_IS_NOT_CONNECTED")) return "/authenticator";
    if (response.errors.includes("TWO_FACTOR_CODE_REQUIRED")) {
        if (!response.data) return null;
        if (response.data.availableTwoFactorProviders.includes(0))
            return "/two-factor-authentication";
        if (response.data.availableTwoFactorProviders.includes(1))
            return "/two-factor-authentication/phone";
    }
    if (response.errors.includes("PHONE_IS_NOT_CONNECTED")) return "/phoneAuthenticator";
    return null;
}